import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box } from 'components/Layout/Layout';
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';

function Profile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <BasePage>
      <Content>
        <Box mb={'3vh'}>My profile page</Box>
      </Content>
    </BasePage>
  );
}

export default observer(Profile);
